export const messageToShowOnBasisOfAction = actionToTake => {

    let message;

    if (actionToTake === 'APPROVE') {

        message = 'LABOR_RATE_APPROVED_SUCCESSFULLY';

    }

    if (actionToTake === 'REJECT') {

        message = 'LABOR_RATE_REJECTED_SUCCESSFULLY';

    }

    if (actionToTake === 'RETURN') {

        message = 'LABOR_RATE_RETURNED_SUCCESSFULLY';

    }
    return message;

};



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/services/message-selection.js